import { Component, ChangeDetectionStrategy, effect, inject, input, output } from '@angular/core';
import { Contact, CONTACT_NAME_TYPES } from '../dynamic-contacts.model';
import { SelectItem } from 'primeng/api';
import { ReportExportViewService } from '../../../../report-export-view.service';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { NgClass, UpperCasePipe } from '@angular/common';
import { L10nTranslatePipe } from 'angular-l10n';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-contact-settings',
  templateUrl: './contact-settings.component.html',
  styleUrl: './contact-settings.component.scss',
  imports: [MatFormField, MatSelect, MatOption, NgClass, UpperCasePipe, L10nTranslatePipe],
})
export class ContactSettingsComponent {
  private readonly reportExportViewService = inject(ReportExportViewService);

  selectedPhone: string;
  nameCatalog = CONTACT_NAME_TYPES;
  selectedName: string;
  readonly contactInfo = input<Contact[]>([]);
  readonly reportId = input.required<number>();
  readonly selectedContact = input.required<Contact>();
  readonly phoneCatalog = input.required<SelectItem[]>();
  readonly refreshContacts = output();

  constructor() {
    effect(() => {
      const selectedContact = this.selectedContact();
      if (selectedContact) {
        this.selectedPhone = selectedContact.phoneType ? selectedContact.phoneType : 'Business Phone';
        this.selectedName = selectedContact.nameType ? selectedContact.nameType.toString() : '1';
      }
    });
  }

  phoneSelection({ value }) {
    this.selectedPhone = value;
    this.setContactSetting();
  }
  nameSelection({ value }) {
    this.selectedName = value;
    this.setContactSetting();
  }
  private setContactSetting() {
    const selectedContact = this.selectedContact();
    selectedContact.phoneType = this.selectedPhone;
    selectedContact.nameType = Number(this.selectedName);
    this.reportExportViewService
      .setReportContactSetting(this.reportId(), selectedContact)
      .subscribe(() => this.refreshContacts.emit());
  }
}
